import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import {useTranslation} from "react-i18next";


const SelectMinutes = ({onChange, value, size = 'small'}) => {

    const {t} = useTranslation()

    const data = Array.from({length: 60}, (_, i) => {
        return {
            value:i,
            label: i > 9 ? i : `0${i}`
        }
    });

    return (
        <SelectCustom
            label={t('base.minutes')}
            size={size}
            value={value}
            onChange={onChange}
            data={data}
        />
    )
}

export default SelectMinutes;